export default __webpack_public_path__ + "static/media/MaskGroup251.3b759cf2.png";